import { capturePageEvent } from '../ravenUtils';
import BaseReporter from './BaseReporter';

import { ReporterAction } from '../types';

import { PageLoadMetrics } from '../Metrics';

export default class UnexpectedRouteReporter extends BaseReporter {
  notifiedRoutes: Set<string>;

  constructor() {
    super();
    this.notifiedRoutes = new Set();
  }

  report(action: ReporterAction) {
    if (
      action.type === 'COMPONENT_RENDERED' ||
      (this.isResolved(action.payload.entry.id) &&
        action.type !== 'CHECKS_CHANGED')
    ) {
      return;
    }

    const {
      entry: { pathname },
    } = action.payload;

    if (action.type === 'ROUTE_UNEXPECTED') {
      if (!this.notifiedRoutes.has(pathname)) {
        capturePageEvent('react-rhumb-event', {
          extra: {
            eventName: 'UnexpectedRouteVisited',
            pathname,
          },
        });

        this.captureUnexpectedRoute(pathname);
        this.notifiedRoutes.add(pathname);
        PageLoadMetrics.counter('unexpected-route').increment();
      }

      this.markResolved(action.payload.entry.id);
    }
  }
}
